import styled from 'styled-components';
import { PopoverArrowMixin } from '../../mixins/components/PopoverArrowMixin';
/**
 * A helper for the [`Popover`](#/Dialog%20components?id=popover) component.
 *
 * @since 7.0.0
 */

var PopoverArrow = /*#__PURE__*/styled.div.withConfig({
  displayName: "PopoverArrow",
  componentId: "c11n-8-64-0__sc-10mxq8o-0"
})(["", ""], PopoverArrowMixin);
/** @component */

export default PopoverArrow;
export var StyledPopoverArrow = PopoverArrow;